import SectionHeader from "../include/SectionHeader";

const PrivacyPolicy = () => {
    return (
        <section className="theme_content_section py-5">
            <div className="container">
                <SectionHeader title="Privacy Policy" />

                <div className="row">
                    <div className="col-lg-12">
                        <div className="theme_content">

                            <h4>1. PURPOSE</h4>
                            <p>
                                This Policy sets out the way in which we process your information when you use our website or other digital platforms in accordance with applicable data protection laws.
                            </p>

                            <h4>2. APPLICABILITY</h4>
                            <p>
                                This Policy applies to individuals visiting our website. The Policy applies only to the information we collect through our website, in email, text and other electronic communication received through or in connection with our website.

                            </p>

                            <h4>3. INFORMATION WE MAY PROCESS (“Personal Data”)</h4>

                            <ol className="wp-block-list">
                                <li>
                                    We use your Personal Information for providing and improving the Service and data subjects (hereinafter referred to as “you” or “your”) personal data are collected, how they’re handled, and how your privacy is protected. In this policy, “we”, “us” and “our” refer to Lifeline Tulasi Hospital (Hyderabad).
                                </li>
                                <li>
                                    We may collect your personal data including your email id, demographic information including country, postcode, first name/last name, job title, mobile number, social media profile, preferences and interests.
                                </li>
                                <li>
                                    We may also capture additional personal data in the form of various usage and user metrics when you use our website including cookies, IP addresses, device and software identifiers, referring and exit URLs, onsite behaviour and usage information, feature use metrics and statistics, usage history, MAC Address, mobile unique device ID and other similar information.
                                </li>
                                <li>
                                    While some of this data is captured directly from you, for example by way of web forms and web log servers, others can be captured indirectly from third parties, for example tracing organization details, preferences and interests on the basis of IP address and browsing history respectively.
                                </li>
                            </ol>

                            <h4>4. WHAT INFORMATION DO WE COLLECT?</h4>
                            <p>
                                We collect information from you when you visit our website, register on our site, place
                                an order, subscribe to our newsletter, respond to a survey or fill out a form.
                            </p>
                            <ul>
                                <li>Phone Numbers</li>
                                <li>Email Addresses</li>
                                <li>Name / username</li>
                                <li>Billing Addresses</li>
                            </ul>

                            <h4>5. LOG DATA</h4>
                            <p>
                                When you use our Site, we may automatically collect and store certain information in
                                server logs through a mobile device (Log Data).
                                <br />
                                This may include:
                                <ul>
                                    <li>details of how you used our Site;</li>
                                    <li>Internet protocol address (IP);</li>
                                    <li>device event information such as crashes, system activity, hardware settings,
                                    browser type, browser language, the date and time of your request and referral URL;
                                    and/or</li>
                                    <li>cookies that may uniquely identify your browser.</li>
                                    <li>your computer’s Internet Protocol (“IP”) address, browser type, browser
                                    version, the pages of our Service that you visit, the time and date of your visit, the
                                    time spent on those pages and other statistics.</li>
                                </ul>
                                In addition, we may use third-party services such as Google Analytics that collect,
                                monitor and analyse this type of information in order to increase our Service’s
                                functionality. These third-party service providers have their own privacy policies
                                addressing how they use such information.
                            </p>

                            <h4>6. LOCATION INFORMATION</h4>
                            <p>
                                We may use and store information about your location, if you give us permission to do
                                so. We use this information to provide features of our Service, to improve and
                                customise our Service. You can enable or disable location services when you use our
                                Service at any time, through your mobile device settings.
                            </p>

                            <h4>7. COOKIES</h4>
                            <p>
                                Cookies are alphanumeric identifiers with small amount of data that is commonly used as
                                an anonymous unique identifier. Cookies are sent to your browser from the website that
                                you visit and are stored on your computer’s hard drive.
                                <br />
                                Our website uses these “cookies” to collect information and to improve our Service.
                                You can accept the cookies to be placed on your browser by clicking on the “Allow
                                Cookies” or “I Agree” button.
                                <br />
                                You can find out more about which cookies we are using or switch them off in settings.
                                Further details on cookies are available as a part of our website cookie notice. If you
                                select “Allow Cookies” or “I Agree” as mentioned above, at any time you also have the
                                option to change/control your cookies through your browser settings. For instructions
                                on changing your browser settings, select your browser:
                                <br />
                                <ul>
                                    <li>Chrome</li>
                                    <li>Firefox</li>
                                    <li>Internet Explorer</li>
                                    <li>Opera</li>
                                    <li>Safari</li>
                                </ul>
                                However, if you do not accept cookies, you may not be able to use some portions of our
                                Service.
                            </p>

                            <h4>8. SERVICE PROVIDER</h4>
                            <p>
                                We may employ third-party companies and individuals to facilitate our Service, to
                                provide the Service on our behalf, to perform Service-related services or to assist us
                                in analysing how our Service is used.
                                <br />
                                These third parties have access to your Personal Information only to perform these
                                tasks on our behalf and are obligated not to disclose or use it for any other purpose.
                            </p>

                            <h4>9. THIRD-PARTY SERVICES</h4>
                            <p>
                                We may display, include or make available third-party content (including data,
                                information, applications and other products services) or provide links to third-party
                                websites or services (“Third-Party Services”).
                                <br />
                                You acknowledge and agree that Lifeline Tulasi Hospital shall not be responsible for any
                                Third-Party Services, including their accuracy, completeness, timeliness, validity,
                                copyright compliance, legality, decency, quality or any other aspect thereof.
                                <br />
                                The Lifeline Tulasi Hospital does not assume and shall not have any liability or
                                responsibility to you or any other person or entity for any Third-Party Services.
                                <br />
                                Third-Party Services and links thereto are provided solely as a convenience to you and
                                you access and use them entirely at your own risk and subject to such third-parties’
                                terms and conditions.
                            </p>

                            <h4>10. KIDS PRIVACY POLICY</h4>
                            <p>
                                We do not address anyone under the age of 13. The Services are not intended for users
                                under the age of 13. We do not knowingly collect any Personal data from children under
                                13 or market to or solicit information from anyone under the age of 13. If we become
                                aware that we have collected Personal Data from anyone under the age of 13, we will
                                remove all the information from our servers as soon as possible unless it is with the
                                consent and involvement of a parent or guardian.
                            </p>

                            <h4>11. COMMUNICATIONS</h4>
                            <p>
                                We may use your Personal Information to contact you with newsletters, marketing or
                                promotional materials and other information that may be of interest to you. You may
                                opt out of receiving any, or all, of these communications from us by following the
                                unsubscribe link or instructions provided in any email we send.
                            </p>

                            <h4>12. HOW DO WE PROTECT YOUR INFORMATION?</h4>
                            <p>
                                We implement appropriate physical, electronic, procedural and managerial procedures to
                                safeguard your information against loss, unauthorized access, misuse or modification.
                                With a variety of security measures to maintain the safety of your personal
                                information when you place an order or enter, submit, or access your personal
                                information. After a transaction, your private information (credit cards, social
                                security numbers, financials, etc.) is never kept on file.
                                <br />
                                We cannot, however, ensure or warrant the absolute security of any information you
                                transmit to The Lifeline Tulasi Hospital or guarantee that your information on the Service
                                may not be accessed, disclosed, altered, or destroyed by a breach of any of our
                                physical, technical, or managerial safeguards. We strive to use commercially
                                acceptable means for protecting your information.
                            </p>

                            <h4>13. COMPLIANCE WITH LAWS</h4>
                            <p>
                                We will disclose your Personal Information where required to do so by law or subpoena
                                or if we believe that such action is necessary to comply with the law and the
                                reasonable requests of law enforcement or to protect the security or integrity of our
                                Service.
                            </p>

                            <h4>14. SECURITY</h4>
                            <p>
                                The security of your Personal Information is important to us; we have implemented
                                appropriate physical, electronic, procedural safeguards to safeguard your information
                                against loss, unauthorized access, misuse or modification but remember that no method
                                of transmission over the Internet, or method of electronic storage is 100% secure.
                                <br />
                                We require any third parties processing your information to implement the same levels
                                of protection with respect to your data.
                                <br />
                                While we strive to use commercially acceptable means to protect your Personal
                                Information, we cannot guarantee its absolute security.
                            </p>

                            <h4>15. INTERNATIONAL TRANSFER</h4>
                            <p>
                                Your information, including Personal Information, may be transferred to — and
                                maintained on — computers located outside of your state, province, country or other
                                governmental jurisdiction where the data protection laws may differ from those from
                                your jurisdiction.
                                <br />
                                If you are located outside India and choose to provide information to us, please note
                                that we transfer the information, including Personal Information, to India and
                                process it there.
                                <br />
                                Your consent to this Privacy Policy followed by your submission of such information
                                represents your agreement to that transfer.
                            </p>

                            <h4>16. LINKS TO OTHER SITES</h4>
                            <p>
                                This Privacy Policy applies only to our Services. The Service may contain links to
                                other sites that are not operated or controlled by us. If you click on a third-party
                                link, you will be directed to that third party’s site. We strongly advise you to review
                                the Privacy Policy of every site you visit. We have no control over, and assume no
                                responsibility for, the content, privacy policies or practices of any third-party
                                sites or services.
                                <br />
                                Your browsing and interaction on any other website, including those that have a link
                                on our platform, is subject to that website’s own rules and policies. Such third
                                parties may use their own cookies or other methods to collect information about you.
                            </p>

                            <h4>17. GROUNDS FOR LAWFUL PROCESSING OF PERSONAL DATA</h4>
                            <p>
                                When we process your Personal Data, we do so primarily in connection with marketing,
                                sale and promotion of services which we provide or which are procured using our
                                services and to improve and enhance the range of those services and offerings. The
                                Lifeline Tulasi Hospital relies on the following legal grounds for the collection, use,
                                sharing, and processing of Personal Information as described in this Privacy Policy:
                                <ul>
                                    <li>when we process cookies, with your explicit consent; or</li>
                                    <li>when we process your personal data for communication, sales and marketing,
                                    registration and subscriptions purposes, where processing is necessary for the
                                    purpose of pursuing our legitimate interests.</li>
                                    <li>Performance of the contract with our users;</li>
                                    <li>Consent, as permitted by applicable law;</li>
                                    <li>Fraud prevention, misuse of company IT systems, or money laundering; and/or</li>
                                    <li>Performance of the contract with our users;</li>
                                    <li>detect, prevent or otherwise address fraud, security or technical issues; and/or</li>
                                    <li>protect against harm to the rights, property or safety of The Lifeline Tulasi Hospital, our users or the public, as required or permitted by law.</li>
                                </ul>
                            </p>

                            <h4>18. CHANGES TO THIS PRIVACY POLICY</h4>
                            <p>
                                We may update our Privacy Policy from time to time. We will notify you of any changes
                                by posting the new Privacy Policy on this page. You are advised to review this Privacy
                                Policy periodically for any changes. Changes to this Privacy Policy are effective
                                when they are posted on this page.
                            </p>

                            <h4>19. CONTACT US</h4>
                            <p>
                                In case you have any questions, comments or concerns about this policy or wish to
                                exercise any of the above-mentioned rights, you can contact:
                            </p>

                            <p>
                                <strong>Lifeline Tulasi Hospital</strong><br />
                                A-12, EC Complex, ECIL X Road, Kushaiguda,<br />
                                Hyderabad, Telangana, India <br />
                                +91 99942 88800<br />
                                +91 97919 88800<br />
                                Do you have a Question? <br />
                                infohyd@lih.bz
                            </p>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PrivacyPolicy;
